import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OnboardingFinishResponse } from '../../../shared/models/routeTyping';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastService } from '../../../shared/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OnboardingFinishApiService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {}

  getOnboardingResponse(): Observable<OnboardingFinishResponse> {
    return this.http.get<OnboardingFinishResponse>(`/api/backoffice/v2/customer_portal/onboarding/`).pipe(
      catchError((error) => {
        this.router.navigateByUrl('/dashboard');
        this.toastService.add({ type: 'error', message: this.translateService.instant('Common.Errors.PageCouldNotBeLoaded') });
        return of();
      }),
    );
  }
}
